"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefinitionManager = void 0;
const tslib_1 = require("tslib");
class DefinitionManager {
    /**
     * 创建一个 definitionManager 的实例。如果有提供 rootSchema，就将其以 `#` 为 name 添加到定义里
     */
    constructor(opts = {}) {
        /** 根别名，例如 `#` -> rootSchema */
        this.definitions = {};
        if (opts.root)
            this.addDefinition('#', opts.root);
    }
    addDefinition(name, schema) {
        const { definitions } = schema;
        this.definitions[name] = schema;
        // 有 definitions 的话可以额外缓存
        if (definitions) {
            definitions.forEach(sub => {
                const { id } = sub, rest = tslib_1.__rest(sub, ["id"]);
                if (!id)
                    return;
                this.addDefinition(`${name}/definitions/${id}`, rest);
            });
        }
    }
    /**
     * @param name 例如 `#`、`#/definitions/foobar` 以及 `#/fields/foobar` 等
     */
    getDefinition(name) {
        const tmp1 = this.definitions[name];
        if (tmp1)
            return tmp1;
        const parts = name.split('/');
        let ret = this.definitions[parts.shift()];
        while (ret && parts.length) {
            let key = parts.shift();
            if (Array.isArray(ret))
                ret = ret.find(x => x && x.id === key);
            else if (ret && typeof ret === 'object')
                ret = ret[key];
        }
        return ret;
    }
    /**
     * 如果一个 DataSchema 设置了 $ref，就从 definitions 里取配置，并且与当前的融合，返回新的 DataSchema
     *
     * 否则返回原样
     */
    patchSchema(schema) {
        var _a;
        if (!schema)
            return schema;
        if (!schema.$ref) {
            if (!schema.type)
                return Object.assign({ type: "any" }, schema);
            return schema;
        }
        const { $ref } = schema, rest1 = tslib_1.__rest(schema, ["$ref"]);
        const rest = Object.assign({ type: "any" }, rest1);
        if ((_a = rest.__ds_refs) === null || _a === void 0 ? void 0 : _a.includes($ref)) {
            throw new Error('circular $ref is found');
        }
        const base = this.patchSchema(this.getDefinition($ref)); // 处理递归的问题，但是没考虑间接循环引用
        if (!base)
            return rest;
        const ans = Object.assign({}, base);
        // 这些需要特殊处理的，多一层 merge
        Object.keys(rest).forEach((k) => {
            const newVal = rest[k];
            const oldVal = ans[k];
            if (typeof oldVal === 'undefined') {
                ans[k] = rest[k];
                return;
            }
            if (Array.isArray(oldVal) && Array.isArray(newVal)) {
                const newArr = [...oldVal];
                newVal.forEach((it) => {
                    const spidx = typeof it['id'] === 'undefined' ? -1 : newArr.findIndex(x => x['id'] === it['id']);
                    if (spidx !== -1)
                        newArr.splice(spidx, 1, it);
                    else
                        newArr.unshift(it);
                });
                // @ts-ignore
                ans[k] = newArr;
                return;
            }
            if (oldVal && newVal && typeof oldVal === 'object' && typeof newVal === 'object') {
                Object.assign(ans[k], newVal);
            }
        });
        ans.__ds_refs = [...rest.__ds_refs || [], $ref];
        return ans;
    }
}
exports.DefinitionManager = DefinitionManager;
//# sourceMappingURL=DefinitionManager.js.map